import { storage } from './storage.js';

export const admin = {
  activeTab: 'books',
  currentEditItem: null,
  currentEditSection: null,

  init() {
    this.bindEvents();
  },

  showToast(message, type = 'success') {
    let container = document.getElementById('toast-container');
    if (!container) {
      container = document.createElement('div');
      container.id = 'toast-container';
      container.className = 'toast-container';
      document.body.appendChild(container);
    }

    const toast = document.createElement('div');
    toast.className = `toast ${type}`;
    const icon = type === 'success' ? 'fa-circle-check' : 'fa-triangle-exclamation';
    toast.innerHTML = `<i class="fa-solid ${icon}"></i><span>${message}</span>`;
    container.appendChild(toast);

    setTimeout(() => {
      toast.style.opacity = '0';
      toast.style.transform = 'translateX(100%)';
      toast.style.transition = '0.3s ease';
      setTimeout(() => toast.remove(), 300);
    }, 3200);
  },

  bindEvents() {
    // Open Admin trigger
    const adminBtn = document.getElementById('btn-open-admin');
    if (adminBtn) {
      adminBtn.addEventListener('click', () => this.handleOpenAdmin());
    }

    // Direct edit about notice trigger
    const editAboutBtn = document.getElementById('btn-quick-edit-about');
    if (editAboutBtn) {
      editAboutBtn.addEventListener('click', () => {
        this.handleOpenAdmin('about');
      });
    }

    // PIN Submit
    const pinForm = document.getElementById('pin-form');
    if (pinForm) {
      pinForm.addEventListener('submit', (e) => {
        e.preventDefault();
        this.verifyPin();
      });
    }

    // Close PIN Modal
    const pinClose = document.getElementById('pin-modal-close');
    if (pinClose) {
      pinClose.addEventListener('click', () => this.closePinModal());
    }

    // Close Admin Modal
    const adminClose = document.getElementById('admin-modal-close');
    if (adminClose) {
      adminClose.addEventListener('click', () => this.closeAdminModal());
    }

    // Admin Tabs
    const tabs = document.querySelectorAll('.admin-tab-btn');
    tabs.forEach(tab => {
      tab.addEventListener('click', (e) => {
        const targetTab = e.currentTarget.dataset.tab;
        this.switchTab(targetTab);
      });
    });

    // Add Item Button
    const addItemBtn = document.getElementById('btn-admin-add-new');
    if (addItemBtn) {
      addItemBtn.addEventListener('click', () => this.openAddModal());
    }

    // Form Modal Close
    const formClose = document.getElementById('form-modal-close');
    const formCancel = document.getElementById('btn-form-cancel');
    if (formClose) formClose.addEventListener('click', () => this.closeFormModal());
    if (formCancel) formCancel.addEventListener('click', () => this.closeFormModal());

    // Item Form Submit
    const itemForm = document.getElementById('admin-item-form');
    if (itemForm) {
      itemForm.addEventListener('submit', (e) => {
        e.preventDefault();
        this.saveCurrentItem();
      });
    }

    // About Form Submit
    const aboutForm = document.getElementById('admin-about-form');
    if (aboutForm) {
      aboutForm.addEventListener('submit', (e) => {
        e.preventDefault();
        this.saveAboutProfiles();
      });
    }

    // Backup buttons
    const exportBtn = document.getElementById('btn-admin-export');
    if (exportBtn) {
      exportBtn.addEventListener('click', () => {
        storage.exportJSON();
        this.showToast('فایلی هەڵگرتن (Backup) بە سەرکەوتوویی دابەزێنرا!');
      });
    }

    const importInput = document.getElementById('admin-import-file');
    if (importInput) {
      importInput.addEventListener('change', (e) => this.handleImportFile(e));
    }

    const resetBtn = document.getElementById('btn-admin-reset');
    if (resetBtn) {
      resetBtn.addEventListener('click', () => {
        if (confirm('دڵنیایت لە گەڕاندنەوەی سەرجەم زانیارییەکان بۆ دۆخی بنەڕەتی و سڕینەوەی گۆڕانکارییەکان؟')) {
          storage.resetDefaults();
          this.renderTabContent();
          this.showToast('هەموو زانیارییەکان گەڕێنرانەوە دۆخی بنەڕەتی!');
        }
      });
    }
  },

  handleOpenAdmin(initialTab = 'books') {
    const isAuth = sessionStorage.getItem('isAdminAuth') === 'true';
    if (isAuth) {
      this.openAdminDashboard(initialTab);
    } else {
      this.openPinModal(initialTab);
    }
  },

  openPinModal(targetTabAfterAuth = 'books') {
    this.targetTabAfterAuth = targetTabAfterAuth;
    const modal = document.getElementById('pin-modal');
    const input = document.getElementById('admin-pin-input');
    if (modal) {
      modal.classList.add('active');
      if (input) {
        input.value = '';
        input.focus();
      }
    }
  },

  closePinModal() {
    const modal = document.getElementById('pin-modal');
    if (modal) modal.classList.remove('active');
  },

  verifyPin() {
    const input = document.getElementById('admin-pin-input');
    const pinVal = input ? input.value.trim() : '';

    // Admin Password
    if (pinVal === 'yg45ht') {
      sessionStorage.setItem('isAdminAuth', 'true');
      this.closePinModal();
      this.showToast('بەخێربێیت بۆ پانێڵی بەڕێوەبەر!');
      this.openAdminDashboard(this.targetTabAfterAuth || 'books');
    } else {
      this.showToast('وشەی نهێنی هەڵەیە! تکایە دووبارە تاقی بکەرەوە.', 'error');
      if (input) {
        input.value = '';
        input.focus();
      }
    }
  },

  openAdminDashboard(tabName = 'books') {
    const modal = document.getElementById('admin-modal');
    if (modal) {
      modal.classList.add('active');
      this.switchTab(tabName);
    }
  },

  closeAdminModal() {
    const modal = document.getElementById('admin-modal');
    if (modal) modal.classList.remove('active');
  },

  switchTab(tabName) {
    this.activeTab = tabName;
    document.querySelectorAll('.admin-tab-btn').forEach(btn => {
      btn.classList.toggle('active', btn.dataset.tab === tabName);
    });

    const itemsView = document.getElementById('admin-items-view');
    const aboutView = document.getElementById('admin-about-view');
    const backupView = document.getElementById('admin-backup-view');
    const addBtn = document.getElementById('btn-admin-add-new');

    if (tabName === 'about') {
      if (itemsView) itemsView.style.display = 'none';
      if (backupView) backupView.style.display = 'none';
      if (aboutView) aboutView.style.display = 'block';
      if (addBtn) addBtn.style.display = 'none';
      this.loadAboutFormData();
    } else if (tabName === 'backup') {
      if (itemsView) itemsView.style.display = 'none';
      if (aboutView) aboutView.style.display = 'none';
      if (backupView) backupView.style.display = 'block';
      if (addBtn) addBtn.style.display = 'none';
    } else {
      if (aboutView) aboutView.style.display = 'none';
      if (backupView) backupView.style.display = 'none';
      if (itemsView) itemsView.style.display = 'block';
      if (addBtn) {
        addBtn.style.display = 'inline-flex';
        const labels = {
          books: 'زیادکردنی کتێبی نوێ',
          films: 'زیادکردنی فیلم / ئەنیمێ',
          games: 'زیادکردنی یاری نوێ',
          apps: 'زیادکردنی بەرنامەی نوێ'
        };
        addBtn.innerHTML = `<i class="fa-solid fa-plus"></i> ${labels[tabName] || 'زیادکردنی ئایتم'}`;
      }
      this.renderTabContent();
    }
  },

  renderTabContent() {
    const tableContainer = document.getElementById('admin-table-container');
    if (!tableContainer) return;

    const items = storage.getSectionItems(this.activeTab);

    if (items.length === 0) {
      tableContainer.innerHTML = `
        <div class="empty-state" style="padding: 2.5rem 1rem;">
          <i class="fa-solid fa-folder-open"></i>
          <h3>هیچ داتایەک لەم بەشەدا نییە</h3>
          <p>دەتوانیت لە ڕێگەی دوگمەی سەرەوە ئایتمی نوێ زیاد بکەیت.</p>
        </div>
      `;
      return;
    }

    let tableHtml = `
      <div class="admin-table-container">
        <table class="admin-table">
          <thead>
            <tr>
              <th style="width: 70px;">وێنە</th>
              <th>ناونیشان</th>
              <th>جۆر / کاتیگۆری</th>
              <th>هەڵسەنگاندن / ساڵ</th>
              <th style="width: 100px; text-align: right;">کردارەکان</th>
            </tr>
          </thead>
          <tbody>
    `;

    items.forEach(item => {
      let imageSrc = item.cover || item.poster || item.banner || item.icon || '';
      let title = item.titleKurdish ? `${item.titleKurdish} (${item.title})` : item.title;
      let category = item.category || item.genre || item.type || '-';
      let meta = item.year || item.releaseYear || item.version || '';
      let rating = item.rating ? `⭐ ${item.rating}` : '';

      tableHtml += `
        <tr>
          <td>
            <img class="table-thumb" src="${imageSrc}" alt="${item.title}" onerror="this.src='https://images.unsplash.com/photo-1518709268805-4e9042af9f23?w=100'"/>
          </td>
          <td>
            <strong>${title}</strong>
          </td>
          <td><span class="skill-tag">${category}</span></td>
          <td>${meta} ${rating ? `<span style="margin-left: 6px; color: #fbbf24;">${rating}</span>` : ''}</td>
          <td>
            <div class="table-actions" style="justify-content: flex-end;">
              <button class="btn-action-edit" title="دەستکاریکردن" onclick="window.adminApp.openEditModal('${this.activeTab}', '${item.id}')">
                <i class="fa-solid fa-pen"></i>
              </button>
              <button class="btn-action-del" title="سڕینەوە" onclick="window.adminApp.deleteItem('${this.activeTab}', '${item.id}')">
                <i class="fa-solid fa-trash"></i>
              </button>
            </div>
          </td>
        </tr>
      `;
    });

    tableHtml += `</tbody></table></div>`;
    tableContainer.innerHTML = tableHtml;
  },

  deleteItem(section, id) {
    if (confirm('ئایا دڵنیایت دەتەوێت ئەم ئایتمە بسڕیتەوە؟')) {
      const ok = storage.deleteItem(section, id);
      if (ok) {
        this.renderTabContent();
        this.showToast('ئایتمەکە بە سەرکەوتوویی سڕایەوە!');
      }
    }
  },

  openAddModal() {
    this.currentEditItem = null;
    this.currentEditSection = this.activeTab;
    this.buildFormFields(this.activeTab, null);
    
    const modal = document.getElementById('form-modal');
    const modalTitle = document.getElementById('form-modal-title');
    if (modalTitle) {
      const titles = {
        books: 'زیادکردنی کتێبی نوێ',
        films: 'زیادکردنی فیلم / ئەنیمێ / کارتۆن',
        games: 'زیادکردنی یاری نوێ',
        apps: 'زیادکردنی بەرنامەی نوێ'
      };
      modalTitle.textContent = titles[this.activeTab] || 'زیادکردنی ئایتم';
    }
    if (modal) modal.classList.add('active');
  },

  openEditModal(section, id) {
    const items = storage.getSectionItems(section);
    const item = items.find(i => i.id === id);
    if (!item) return;

    this.currentEditItem = item;
    this.currentEditSection = section;
    this.buildFormFields(section, item);

    const modal = document.getElementById('form-modal');
    const modalTitle = document.getElementById('form-modal-title');
    if (modalTitle) {
      modalTitle.textContent = `دەستکاریکردنی: ${item.title}`;
    }
    if (modal) modal.classList.add('active');
  },

  closeFormModal() {
    const modal = document.getElementById('form-modal');
    if (modal) modal.classList.remove('active');
  },

  buildFormFields(section, data = {}) {
    const container = document.getElementById('form-fields-container');
    if (!container) return;

    const v = (key, fallback = '') => (data && data[key] !== undefined ? data[key] : fallback);

    let html = '';

    if (section === 'books') {
      html = `
        <div class="form-group">
          <label>ناوی کتێب بە ئینگلیزی *</label>
          <input class="form-input" name="title" value="${v('title')}" required placeholder="e.g. The Alchemist">
        </div>
        <div class="form-group">
          <label>ناوی کتێب بە کوردی</label>
          <input class="form-input" name="titleKurdish" value="${v('titleKurdish')}" placeholder="وەک: کیمیاگەر">
        </div>
        <div class="form-group">
          <label>نووسەر *</label>
          <input class="form-input" name="author" value="${v('author')}" required placeholder="ناوی نووسەر">
        </div>
        <div class="form-group">
          <label>کاتیگۆری / چەشن</label>
          <input class="form-input" name="category" value="${v('category', 'ڕۆمان و چیرۆک')}" placeholder="وەک: زانست، تەکنەلۆژیا، مێژوو">
        </div>
        <div class="form-group full-width">
          <label><i class="fa-solid fa-image" style="color: #818cf8;"></i> لینکی وێنەی بەرگ یان بانەری کتێب (Cover / Banner URL) *</label>
          <input class="form-input" name="cover" value="${v('cover')}" required placeholder="https://images.unsplash.com/... یان لینکی وێنە">
        </div>
        <div class="form-group">
          <label>ساڵی چاپ</label>
          <input class="form-input" name="year" value="${v('year', '2023')}" placeholder="2024">
        </div>
        <div class="form-group">
          <label>ژمارەی لاپەڕەکان</label>
          <input class="form-input" name="pages" value="${v('pages', '250')}" placeholder="300">
        </div>
        <div class="form-group">
          <label>هەڵسەنگاندن (1 بۆ 5)</label>
          <input class="form-input" type="number" step="0.1" max="5" min="1" name="rating" value="${v('rating', '4.8')}">
        </div>
        <div class="form-group">
          <label>لینکی داگرتن / خوێندنەوە (PDF URL)</label>
          <input class="form-input" name="downloadUrl" value="${v('downloadUrl')}" placeholder="https://...">
        </div>
        <div class="form-group full-width">
          <label>کورتەیەک دەربارەی کتێبەکە</label>
          <textarea class="form-textarea" name="description" placeholder="پوختەی ناوەڕۆکی ئەم کتێبە لێرە بنووسە...">${v('description')}</textarea>
        </div>
      `;
    } else if (section === 'films') {
      const type = v('type', 'movie');
      html = `
        <div class="form-group">
          <label>ناوی بەرهەم (ئینگلیزی) *</label>
          <input class="form-input" name="title" value="${v('title')}" required placeholder="e.g. Interstellar">
        </div>
        <div class="form-group">
          <label>ناوی بەرهەم (کوردی)</label>
          <input class="form-input" name="titleKurdish" value="${v('titleKurdish')}" placeholder="وەک: ئینتەرستێلار">
        </div>
        <div class="form-group">
          <label>جۆری بەرهەم (Type) *</label>
          <select class="form-select" name="type" required>
            <option value="movie" ${type === 'movie' ? 'selected' : ''}>فیلم (Movie)</option>
            <option value="anime" ${type === 'anime' ? 'selected' : ''}>ئەنیمێ (Anime)</option>
            <option value="cartoon" ${type === 'cartoon' ? 'selected' : ''}>کارتۆن / ئەنیمەیشن (Cartoon)</option>
            <option value="series" ${type === 'series' ? 'selected' : ''}>زنجیرە (Series)</option>
          </select>
        </div>
        <div class="form-group">
          <label>چەشن (Genre)</label>
          <input class="form-input" name="genre" value="${v('genre', 'ئەکشن، سەرکێشی')}" placeholder="ئەکشن، دراما، کۆمیدی">
        </div>
        <div class="form-group full-width">
          <label><i class="fa-solid fa-film" style="color: #38bdf8;"></i> لینکی وێنەی پۆستەر یان بانەر (Poster / Banner URL) *</label>
          <input class="form-input" name="poster" value="${v('poster')}" required placeholder="https://images.unsplash.com/... یان لینکی وێنە">
        </div>
        <div class="form-group">
          <label>ساڵ</label>
          <input class="form-input" name="year" value="${v('year', '2024')}" placeholder="2024">
        </div>
        <div class="form-group">
          <label>کاتی بەرهەم / وەرز</label>
          <input class="form-input" name="duration" value="${v('duration', '2h 10m')}" placeholder="2h 15m یان 3 وەرز">
        </div>
        <div class="form-group">
          <label>هەڵسەنگاندن (IMDb)</label>
          <input class="form-input" type="number" step="0.1" max="10" min="1" name="rating" value="${v('rating', '8.5')}">
        </div>
        <div class="form-group">
          <label>کوالێتی</label>
          <input class="form-input" name="quality" value="${v('quality', '1080p FHD')}" placeholder="4K UHD / 1080p">
        </div>
        <div class="form-group full-width">
          <label>لینکی ترەیلەر یان بینین (YouTube / Video URL)</label>
          <input class="form-input" name="watchUrl" value="${v('watchUrl')}" placeholder="https://www.youtube.com/watch?v=...">
        </div>
        <div class="form-group full-width">
          <label>چیرۆکی فیلم / کورتە</label>
          <textarea class="form-textarea" name="description" placeholder="پوختەی چیرۆک لێرە بنووسە...">${v('description')}</textarea>
        </div>
      `;
    } else if (section === 'games') {
      html = `
        <div class="form-group">
          <label>ناوی یاری *</label>
          <input class="form-input" name="title" value="${v('title')}" required placeholder="e.g. Elden Ring">
        </div>
        <div class="form-group">
          <label>ناوی کوردی</label>
          <input class="form-input" name="titleKurdish" value="${v('titleKurdish')}" placeholder="وەک: ئێڵدن ڕینگ">
        </div>
        <div class="form-group">
          <label>پلاتفۆرمەکان (Platforms) *</label>
          <input class="form-input" name="platform" value="${v('platform', 'PC, PS5, Xbox')}" required placeholder="PC, PS5, Android, iOS">
        </div>
        <div class="form-group">
          <label>چەشن (Genre)</label>
          <input class="form-input" name="genre" value="${v('genre', 'ئەکشن، RPG')}" placeholder="Open World, Action, Shooter">
        </div>
        <div class="form-group full-width">
          <label><i class="fa-solid fa-gamepad" style="color: #c084fc;"></i> لینکی وێنەی بانەر (Game Banner URL) *</label>
          <input class="form-input" name="banner" value="${v('banner')}" required placeholder="https://images.unsplash.com/... یان لینکی وێنە">
        </div>
        <div class="form-group">
          <label>قەبارەی فایل (Size)</label>
          <input class="form-input" name="fileSize" value="${v('fileSize', '50 GB')}" placeholder="60 GB">
        </div>
        <div class="form-group">
          <label>گەشەپێدەر (Developer)</label>
          <input class="form-input" name="developer" value="${v('developer', 'Rockstar Games')}" placeholder="گەشەپێدەر">
        </div>
        <div class="form-group">
          <label>ساڵی دەرچوون</label>
          <input class="form-input" name="releaseYear" value="${v('releaseYear', '2024')}" placeholder="2024">
        </div>
        <div class="form-group">
          <label>هەڵسەنگاندن (1 بۆ 5)</label>
          <input class="form-input" type="number" step="0.1" max="5" min="1" name="rating" value="${v('rating', '4.9')}">
        </div>
        <div class="form-group full-width">
          <label>لینکی داگرتن / کڕین (Store / Download URL)</label>
          <input class="form-input" name="downloadUrl" value="${v('downloadUrl')}" placeholder="https://store.steampowered.com/...">
        </div>
        <div class="form-group full-width">
          <label>کورتە دەربارەی یارییەکە</label>
          <textarea class="form-textarea" name="description" placeholder="ناساندنی یارییەکە...">${v('description')}</textarea>
        </div>
      `;
    } else if (section === 'apps') {
      html = `
        <div class="form-group">
          <label>ناوی بەرنامە *</label>
          <input class="form-input" name="title" value="${v('title')}" required placeholder="e.g. Visual Studio Code">
        </div>
        <div class="form-group">
          <label>ناوی کوردی</label>
          <input class="form-input" name="titleKurdish" value="${v('titleKurdish')}" placeholder="وەک: ڤیژوەڵ ستۆدیۆ">
        </div>
        <div class="form-group">
          <label>کاتیگۆری</label>
          <input class="form-input" name="category" value="${v('category', 'دیزاین و گرافیک')}" placeholder="بەرنامەسازی، ئامرازەکان">
        </div>
        <div class="form-group">
          <label>سیستەمی کارپێکەر (OS) *</label>
          <input class="form-input" name="os" value="${v('os', 'Windows, macOS')}" required placeholder="Windows, macOS, Android, iOS">
        </div>
        <div class="form-group full-width">
          <label><i class="fa-solid fa-shapes" style="color: #34d399;"></i> لینکی وێنەی ئایکۆن و بانەر (App Icon / Banner URL) *</label>
          <input class="form-input" name="icon" value="${v('icon')}" required placeholder="https://images.unsplash.com/... یان لینکی وێنە">
        </div>
        <div class="form-group">
          <label>وەشان (Version)</label>
          <input class="form-input" name="version" value="${v('version', 'v1.0')}" placeholder="v2.5.0">
        </div>
        <div class="form-group">
          <label>قەبارەی فایل</label>
          <input class="form-input" name="size" value="${v('size', '120 MB')}" placeholder="95 MB">
        </div>
        <div class="form-group">
          <label>گەشەپێدەر / کۆمپانیا</label>
          <input class="form-input" name="developer" value="${v('developer', 'Microsoft')}" placeholder="ناوی کۆمپانیا">
        </div>
        <div class="form-group">
          <label>لینکی داگرتن (Download URL) *</label>
          <input class="form-input" name="downloadUrl" value="${v('downloadUrl')}" required placeholder="https://...">
        </div>
        <div class="form-group full-width">
          <label>کورتە دەربارەی بەرنامەکە</label>
          <textarea class="form-textarea" name="description" placeholder="تایبەتمەندی و زانیاری دەربارەی ئەم ئەپە...">${v('description')}</textarea>
        </div>
      `;
    }

    container.innerHTML = html;
  },

  saveCurrentItem() {
    const form = document.getElementById('admin-item-form');
    if (!form) return;

    const formData = new FormData(form);
    const itemData = {};
    for (let [key, val] of formData.entries()) {
      itemData[key] = val;
    }

    if (itemData.rating) {
      itemData.rating = parseFloat(itemData.rating);
    }

    if (this.currentEditItem) {
      itemData.id = this.currentEditItem.id;
      storage.updateItem(this.currentEditSection, itemData);
      this.showToast('ئایتمەکە بە سەرکەوتوویی نوێکرایەوە!');
    } else {
      storage.addItem(this.currentEditSection, itemData);
      this.showToast('ئایتمی نوێ بە سەرکەوتوویی زیادکرا!');
    }

    this.closeFormModal();
    this.renderTabContent();
  },

  loadAboutFormData() {
    const about = storage.getAbout();
    const p1 = (about.persons && about.persons[0]) || {};
    const p2 = (about.persons && about.persons[1]) || {};

    const fillVal = (id, val) => {
      const el = document.getElementById(id);
      if (el) el.value = val || '';
    };

    fillVal('about-main-title', about.title);
    fillVal('about-main-subtitle', about.subtitle);

    // Person 1
    fillVal('p1-name', p1.name);
    fillVal('p1-role', p1.role);
    fillVal('p1-avatar', p1.avatar);
    fillVal('p1-banner', p1.banner);
    fillVal('p1-bio', p1.bio);
    fillVal('p1-skills', (p1.skills || []).join(', '));
    fillVal('p1-discord', p1.social?.discord);

    // Person 2
    fillVal('p2-name', p2.name);
    fillVal('p2-role', p2.role);
    fillVal('p2-avatar', p2.avatar);
    fillVal('p2-banner', p2.banner);
    fillVal('p2-bio', p2.bio);
    fillVal('p2-skills', (p2.skills || []).join(', '));
    fillVal('p2-discord', p2.social?.discord);
  },

  saveAboutProfiles() {
    const getVal = (id) => {
      const el = document.getElementById(id);
      return el ? el.value.trim() : '';
    };

    const title = getVal('about-main-title');
    const subtitle = getVal('about-main-subtitle');
    storage.updateAboutHeadings(title, subtitle);

    const parseSkills = (str) => str.split(',').map(s => s.trim()).filter(Boolean);

    // Person 1
    const p1 = {
      id: 'p1',
      name: getVal('p1-name'),
      role: getVal('p1-role'),
      avatar: getVal('p1-avatar'),
      banner: getVal('p1-banner'),
      bio: getVal('p1-bio'),
      skills: parseSkills(getVal('p1-skills')),
      social: {
        discord: getVal('p1-discord')
      }
    };
    storage.updatePerson('p1', p1);

    // Person 2
    const p2 = {
      id: 'p2',
      name: getVal('p2-name'),
      role: getVal('p2-role'),
      avatar: getVal('p2-avatar'),
      banner: getVal('p2-banner'),
      bio: getVal('p2-bio'),
      skills: parseSkills(getVal('p2-skills')),
      social: {
        discord: getVal('p2-discord')
      }
    };
    storage.updatePerson('p2', p2);

    this.showToast('زانیارییەکانی دەربارەی هەردوو کەسەکە نوێکرایەوە!');
  },

  handleImportFile(event) {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      const res = storage.importJSON(e.target.result);
      if (res.success) {
        this.showToast('هەموو زانیارییەکان بە سەرکەوتوویی بارکرانەوە!');
        this.renderTabContent();
      } else {
        this.showToast(res.message, 'error');
      }
      event.target.value = '';
    };
    reader.readAsText(file);
  }
};

window.adminApp = admin;
